import axios from 'axios'
// import { MessageBox, Message } from 'element-ui'
// import settings from './settings'

// create an axios instance
const service = axios.create({
  baseURL: 'mancenter.renhegroup.net/website-api/' // url = base url + request url
  // withCredentials: true, // send cookies when cross-domain requests
  // timeout: 5000 // request timeout
})

// request interceptor
service.interceptors.request.use(
  config => {
    // do something before request is sent
    return config
  },
  error => {
    // do something with request error
    console.log(error) // for debug
    return Promise.reject(error)
  }
)

// response interceptor
service.interceptors.response.use(
  response => {
    const res = response.data
    if (response.data.status === 10001) {
      localStorage.removeItem('LTokenD')
      this.router.replace('/')
    }
    return res
  },
  error => {
    console.log('err' + error) // for debug
    Message({
      message: error.message,
      type: 'error',
      duration: 5 * 1000
    })

    return Promise.reject(error)
  }
)

export default service



// WEBPACK FOOTER //
// ./src/assets/js/request.js